import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

export function AddAdditionalCalendars() {
    return (
        <div className='flex flex-dir-col gap-12'>
            <Body size='small' isBold={true}>
                Add more calendars
            </Body>
            <Body size='small'>
                Got more calendars? Feel free to add them here. We support multiple calendars to
                prevent any scheduling conflicts.
            </Body>
            <div className='flex justify-center'>
                {/* @ts-expect-error */}
                <Link as={RoutedLink} to='/my-account/calendar' variant='button-primary' size='big'>
                    Add additional calendars
                </Link>
            </div>
        </div>
    );
}
